"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardModal = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var standard_modal_styles_1 = require("./standard_modal.styles");
var loading_button_1 = require("../../LoadingButton/loading_button");
var StandardModal = function (props) {
    var _a = props.cell.value, callToActionLabel = _a.callToActionLabel, cancelLabel = _a.cancelLabel, loadingLabel = _a.loadingLabel, sendLabel = _a.sendLabel, isLoading = _a.isLoading, isSuccess = _a.isSuccess, isButtonDisabled = _a.isButtonDisabled, disabledTooltipText = _a.disabledTooltipText, disableSend = _a.disableSend, onSetData = _a.onSetData, onOpen = _a.onOpen, header = _a.header;
    var _b = (0, react_1.useState)(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    (0, react_1.useEffect)(function () {
        isSuccess && setIsModalOpen(false);
    }, [isSuccess]);
    var buttonRef = (0, react_1.useRef)(null);
    var ModalFooter = (react_1.default.createElement("div", null,
        react_1.default.createElement(standard_modal_styles_1.CancelButton, { onClick: function () { return setIsModalOpen(false); } }, cancelLabel),
        react_1.default.createElement(loading_button_1.LoadingButton, { withMargin: true, onClickSend: onSetData, isLoading: isLoading, isDisabled: disableSend, loadingLabel: loadingLabel, sendLabel: sendLabel })));
    var modalProps = {
        isOpen: isModalOpen,
        header: header,
        footer: ModalFooter,
        onClose: function () { return setIsModalOpen(false); },
        toggleEl: buttonRef.current,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storm_ui_1.Modal, __assign({}, modalProps), props.children),
        isButtonDisabled ? (react_1.default.createElement(storm_ui_1.Tooltip, { trigger: react_1.default.createElement("div", null,
                react_1.default.createElement(standard_modal_styles_1.CallToActionButton, { disabled: true }, callToActionLabel)), type: "dark" }, disabledTooltipText)) : (react_1.default.createElement(storm_ui_1.TextButton, { onClick: function () {
                onOpen();
                setIsModalOpen(true);
            }, buttonRef: function () { return buttonRef; } }, callToActionLabel))));
};
exports.StandardModal = StandardModal;
